/**
 * 模組頁面代碼 : 1320-UI-04
 * 頁面說明 : 指派條件列表畫面
 * @module web/modules/condition/components/ConditionLitModal
 */

// ----- import from npm modules ----
import React, {useEffect} from 'react';

// ----- import from local modules -----
import {BaseComponent} from '../../../components/BaseComponent';
import enumList from 'web/utils/enumList';
import {useConditionListModal} from '../hooks/useConditionListModal';
import {useDispatch} from 'react-redux';

const ConditionListModal = React.forwardRef((props, ref) => {
  const {
    onCondition,
    conditionList,
    onEditConditionStatus,
    needDispatchListLoad,
    setNeedDispatchListLoad,
  } = props;
  const baseComponent = new BaseComponent(props);
  const {prepareDispatchListTable} = useConditionListModal(baseComponent);

  const dispatch = useDispatch();

  // // 當表格的容器可見後，調整列寬
  const adjustTableWhenVisible = () => {
    // 假設這是表格的容器
    const tableContainer = document.querySelector('#datatable__dispatchList');

    if (tableContainer && tableContainer.offsetParent !== null) {
      const t = prepareDispatchListTable();
      t.columns.adjust().draw();
    } else {
      setTimeout(adjustTableWhenVisible, 100); // 容器不可見，稍後再嘗試
    }
  };

  useEffect(() => {
    if (needDispatchListLoad) {
      setNeedDispatchListLoad(false);

      const maskElement = document.querySelector('#modal-mask-dispatch');
      // 顯示遮罩
      maskElement.style.opacity = '0.5';

      //   // 隱藏遮罩
      maskElement.style.opacity = '0';
      setTimeout(() => {
        maskElement.style.display = 'none';
      }, 200);

      // 重新繪製表格
      adjustTableWhenVisible();
    }
  }, [needDispatchListLoad]);

  useEffect(() => {
    const handleClick = (event) => {
      const currentButton = event.target.closest('.btn');
      if (!currentButton || !currentButton.id.startsWith('edit-condition-')) {
        return;
      }
      const index = parseInt(currentButton.id.split('-')[2]);
      const condition = conditionList[index];
      if (condition) {
        onCondition(enumList.modalMode.edit, condition.conditionCode);
      }
    };
    const handleChange = (event) => {
      const checkbox = event.target.closest('input[type="checkbox"]');
      if (checkbox && checkbox.id.startsWith('eab-condition-')) {
        const index = parseInt(checkbox.id.split('-')[2]);
        const mode = checkbox.checked
          ? enumList.alertModalModeEnums.enable
          : enumList.alertModalModeEnums.disable;
        const updateCondition = conditionList[index];
        if (updateCondition) {
          let message = '';
          if (mode === enumList.alertModalModeEnums.enable) {
            message = `啟用 [ ${updateCondition.conditionName} ]`;
          } else {
            message = `停用 [ ${updateCondition.conditionName} ]`;
          }
          onEditConditionStatus(mode, message, updateCondition.conditionCode);
        } else {
          console.log('No role found at index:', index);
        }
      }
    };
    if (ref.current) {
      ref.current.addEventListener('change', handleChange);
      ref.current.addEventListener('click', handleClick);
    }

    return () => {
      if (ref.current) {
        ref.current.removeEventListener('change', handleChange);
        ref.current.removeEventListener('click', handleClick);
      }
    };
  }, [conditionList]);

  return (
    <div
      ref={ref}
      className="modal fade"
      id="modalConditionList"
      data-bs-backdrop="static"
      data-bs-keyboard="false"
      tabIndex="-1"
      aria-labelledby="modalConditionList"
    >
      <div
        className="modal-dialog modal-dialog-centered
         modal-dialog-scrollable"
      >
        <form
          className="modal__form modal-content needs-validation"
          id="modalRoleListForm"
          noValidate
        >
          <div className="modal-header">
            <h1 className="modal-title fs-5" id="modalPositionListLabel">
              <div className="modal__title__badge">
                <svg className="badge__icon">
                  <use href="#ico-users-edit"></use>
                </svg>
              </div>
              <div className="modal__title__text">指派條件管理</div>
            </h1>
            <button
              type="button"
              className="btn-close btn-cancel"
              data-bs-dismiss="modal"
              aria-label="Close"
            ></button>
          </div>
          <div className="modal-body">
            <div id="modal-mask-dispatch" className="modal-mask"></div>
            <div className="datatable__tool mb-2">
              <div className="d-flex align-items-center gap-2 ms-auto">
                {baseComponent.checkPermission(
                  enumList.moduleEnums.position,
                  enumList.accessModeEnums.create,
                ) && (
                  <button
                    type="button"
                    className="btn btn-sm btn-primary"
                    id="modalRoleBtnNew"
                    onClick={() => onCondition(enumList.modalMode.new)}
                  >
                    <svg className="btn__icon me-2" aria-hidden="true">
                      <use href="#ico-plus"></use>
                    </svg>
                    新增
                  </button>
                )}
              </div>
            </div>
            <div className="datatable__data">
              <table
                id="datatable__dispatchList"
                className="display table table-hover align-middle nowrap"
                style={{width: '100%'}}
              ></table>
            </div>
          </div>
        </form>
      </div>
    </div>
  );
});

export default ConditionListModal;
